import NetworkGraph from "@/components/NetworkGraph";
import { PageHead, Reveal, HUDPanel } from "@/components/ui-kit";

const NetworkPage = () => (
  <div data-testid="network-page" className="pb-24">
    <PageHead
      eyebrow="MODULE 01 // COORDINATION LAYER"
      title="THE ARCMECH NETWORK"
      subtitle="A coordination layer for autonomous machines. AI agents, rovers, drones, humanoids, industrial systems and digital services — discovered and coordinated through one fabric."
      note="SIMULATED NETWORK — INTERFACE DEMO VALUES ONLY"
    />
    <div className="px-5 sm:px-8 max-w-7xl mx-auto">
      <Reveal><NetworkGraph /></Reveal>
      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <Reveal><HUDPanel title="Agents Online" rows={[["COUNT", "1,284", "cyan"], ["ROLE", "COORDINATION"], ["DATA", "SIMULATED"]]} /></Reveal>
        <Reveal delay={0.1}><HUDPanel title="Machines Active" rows={[["COUNT", "3,912", "cyan"], ["ROLE", "EXECUTION"], ["DATA", "SIMULATED"]]} /></Reveal>
        <Reveal delay={0.2}><HUDPanel title="Tasks Processing" rows={[["COUNT", "427", "cyan"], ["ROLE", "MARKET FLOW"], ["DATA", "SIMULATED"]]} /></Reveal>
      </div>
    </div>
  </div>
);

export default NetworkPage;
